import { GoogleGenAI, Modality } from '@google/genai';

// AI生成服务类
export class AIGenerationService {
  private ai: GoogleGenAI;

  constructor() {
    const apiKey = import.meta.env.VITE_GOOGLE_API_KEY || process.env.GOOGLE_API_KEY;
    if (!apiKey) {
      throw new Error('GOOGLE_API_KEY environment variable is not set');
    }
    this.ai = new GoogleGenAI({ apiKey });
  }

  /**
   * 生成发型图像
   * @param prompt 生成提示词
   * @param originalImageBase64 原始图像的base64数据
   * @param mimeType 图像MIME类型
   * @returns 生成的图像URL或错误信息
   */
  async generateHairstyleImage(
    prompt: string,
    originalImageBase64: string,
    mimeType: string = 'image/jpeg'
  ): Promise<{ success: boolean; imageUrl?: string; error?: string }> {
    try {
      console.log('🚀 开始调用Google Nano Banana API...');
      console.log('📝 提示词:', prompt);
      console.log('🖼️ 图像类型:', mimeType);

      // 构建图像部分
      const imagePart = {
        inlineData: {
          data: originalImageBase64,
          mimeType: mimeType,
        },
      };

      // 构建文本部分
      const textPart = { text: prompt };

      console.log('🔄 调用gemini-2.5-flash-image-preview模型...');

      // 调用Google Nano Banana API生成图像
      const response = await this.ai.models.generateContent({
        model: 'gemini-2.5-flash-image-preview',
        contents: { parts: [imagePart, textPart] },
        config: {
          responseModalities: [Modality.IMAGE, Modality.TEXT],
        },
      });

      console.log('✅ Google Nano Banana API调用成功');

      // 从响应中提取生成的图像
      for (const part of response.candidates?.[0]?.content?.parts ?? []) {
        if (part.inlineData) {
          const generatedImageUrl = `data:${part.inlineData.mimeType};base64,${part.inlineData.data}`;
          console.log('🎨 成功生成发型图像');
          
          return {
            success: true,
            imageUrl: generatedImageUrl
          };
        }
      }

      // 如果没有找到图像，返回错误
      console.warn('⚠️ API响应中没有找到生成的图像');
      return {
        success: false,
        error: 'API响应中没有找到生成的图像'
      };

    } catch (error) {
      console.error('❌ Google Nano Banana API error:', error);
      return {
        success: false,
        error: `AI生成失败: ${error instanceof Error ? error.message : '未知错误'}`
      };
    }
  }

  /**
   * 从data URL中提取base64数据
   * @param dataUrl data URL格式的图像
   * @returns base64数据和MIME类型
   */
  extractBase64FromDataUrl(dataUrl: string): { base64: string; mimeType: string } {
    if (!dataUrl.startsWith('data:')) {
      throw new Error('Invalid data URL format');
    }

    const [header, data] = dataUrl.split(',');
    const mimeType = header.split(';')[0].split(':')[1] || 'image/jpeg';
    
    return {
      base64: data,
      mimeType: mimeType
    };
  }
}

// 创建单例实例
export const aiGenerationService = new AIGenerationService();
